/* ---------------------------------------------------------
* This file defines all development constants
------------------------------------------------------------ */

export const API_BASE_URL = 'https://experienciasback.clubpremier.info/api/v1/experiences/';
export const POSTAL_CODE_URL = 'https://0xo55otzd1.execute-api.us-east-1.amazonaws.com/step1/postal_code/show';
export const NEWSLETTER_SUBMIT_URL = 'https://member.clubpremier.info/api/v1/preference/subscribe';
export const OUTSESION = 'https://member.clubpremier.info/salir';
export const LOGIN_URL = 'https://member.clubpremier.info/login/auth';
export const DEFAULT_URL_EXP = 'https://experiencias.clubpremier.info';
export const RECOVERY_ACCOUNT_LINK = 'https://member.clubpremier.info/individual/recuperacuenta';
export const RECOVERY_NIP_LINK = 'https://member.clubpremier.info/recuperar-nip';
export const REGISTER_LINK = 'https://member.clubpremier.info/registro';
export const CP_LINK = 'https://www.clubpremier.info/mx/bienvenido/';
export const REDIRECT_LOGIN_LINK = 'https://member.clubpremier.info/login?url=https%3A%2F%2Fexperiencias.clubpremier.info';
export const SANTANDER_LINK = 'https://santander.clubpremier.info/';
export const AMEX_LINK = 'https://americanexpressaeromexico.clubpremier.info/';
export const ACCUMULATE_POINTS_LINK = 'https://www.clubpremier.info/mx/acumula-puntos-premier';
